const isNewClient = !!window.VanishPCSDK

if (isNewClient) {
  const { ipcRenderer } = window.VanishPCSDK
  ipcRenderer.on('client-request-quit', () => {
    ipcRenderer.send('client-quit')
  })
}



// WEBPACK FOOTER //
// ./src/utils/pcBridge.js